import React from "react";

import { determineBrand } from "../util/theme.js";

function GlobalCssVars() {
  const brand = determineBrand();
  const isEveryday = brand === "everyday";
  const theme = themeVars[brand];

  return (
    <style>
      {`:root {
      --theme-primary-color: ${theme.primary};
      --theme-card-color: ${theme.card};
      --theme-text-color: ${theme.textColor || "inherit"};
      --theme-button-color: ${theme.buttonColor || theme.primary};
      --theme-font: ${theme.font};
      --theme-font-header: ${theme.header};
      --theme-font-sub-header: ${theme.subHeader};
      --theme-hero-font: ${theme.heroFont};
      --theme-hero-font-tablet: ${theme.heroFontTablet};
      --theme-hero-font-mobile: ${theme.heroFontMobile};
      --theme-hero-font-small: ${theme.heroFontSmall};
      --theme-hero-transform: ${theme.heroTransform};
      --theme-hero-bg-color: ${theme.heroDefaultBg};
      --theme-heading-line-height: ${theme.headingLineHeight};
      --theme-link-hover-decor: ${isEveryday ? "none" : "underline"};
      --theme-blog-width: ${isEveryday ? "90%" : "65%"};
      --theme-site-bg: ${theme.siteBg};
      --theme-header-letter-spacing: ${theme.headerLetterSpacing};
      --theme-font-feature-settings: ${isEveryday
          ? ""
          : `"rlig" 1, "rvrn" 1, "kern" 1, "rclt" 1, "ss01" 1, "calt" 1, "liga" 1`
        };
    }`}
    </style>
  );
}

export default GlobalCssVars;

const themeVars = {
  "barkers-nz": {
    primary: "#3D3935",
    card: "#e5e2dd",
    textColor: undefined,
    buttonColor: "#3D3935",
    font: "'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    header: "'trailers', Impact, 'Arial Black', sans-serif",
    subHeader: "'Doyle', Georgia, 'Times New Roman', serif",
    heroFont: "110px",
    heroFontTablet: "100px",
    heroFontMobile: "74px",
    heroFontSmall: "50px",
    heroTransform: "uppercase",
    heroDefaultBg: "#fadb8b",
    headingLineHeight: "80%",
    siteBg: "white",
    headerLetterSpacing: "normal",
  },
  "barkers-aus": {
    primary: "#3D3935",
    card: "#e5e2dd",
    textColor: undefined,
    buttonColor: "#3D3935",
    font: "'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    header: "'trailers', Impact, 'Arial Black', sans-serif",
    subHeader: "'Doyle', Georgia, 'Times New Roman', serif",
    heroFont: "110px",
    heroFontTablet: "100px",
    heroFontMobile: "74px",
    heroFontSmall: "50px",
    heroTransform: "uppercase",
    heroDefaultBg: "#fadb8b",
    headingLineHeight: "80%",
    siteBg: "white",
    headerLetterSpacing: "normal",
  },
  professional: {
    primary: "#3D3935",
    card: "#e5e2dd",
    textColor: undefined,
    buttonColor: "#3D3935",
    font: "'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    header: "'trailers', Impact, 'Arial Black', sans-serif",
    subHeader: "'Doyle', Georgia, 'Times New Roman', serif",
    heroFont: "110px",
    heroFontTablet: "100px",
    heroFontMobile: "74px",
    heroFontSmall: "50px",
    heroTransform: "uppercase",
    heroDefaultBg: "#fadb8b",
    headingLineHeight: "80%",
    siteBg: "white",
    headerLetterSpacing: "normal",
  },
  anathoth: {
    // primary: "#8B2635",
    primary: "rgb(71, 47, 47)",
    card: "rgb(250, 249, 242)",
    textColor: "rgb(71, 47, 47)",
    buttonColor: "rgb(177, 31, 40)",
    font: "'Neutra', sans-serif",
    header: "'NeutraFace', sans-serif",
    subHeader: "'NeutraFace', sans-serif",
    heroFont: "50px",
    heroFontTablet: "50px",
    heroFontMobile: "38px",
    heroFontSmall: "32px",
    heroTransform: "none",
    heroDefaultBg: "#f5f0e3",
    headingLineHeight: "1.2",
    siteBg: "#FCFBF7",
    headerLetterSpacing: "0.16em",
  },
  everyday: {
    primary: "#35574b",
    card: "#f5f0e3",
    textColor: undefined,
    buttonColor: "#35574b",
    font: "'GT-Walsheim', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    header: "'GT-Pressura', 'Courier New', monospace",
    subHeader: "'GT-Pressura', 'Courier New', monospace",
    heroFont: "70px",
    heroFontTablet: "50px",
    heroFontMobile: "50px",
    heroFontSmall: "40px",
    heroTransform: "none",
    heroDefaultBg: "transparent",
    headingLineHeight: "1",
    siteBg: "white",
    headerLetterSpacing: "normal",
  },
};
